import { EventBus } from 'bussin-js';

export const GlobalEventBus = new EventBus();
